import script from "./PollDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PollDialog.vue?vue&type=script&setup=true&lang=js"

import "./PollDialog.vue?vue&type=style&index=0&id=37da4631&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37da4631"]])

export default __exports__